import { DecisionCanvas } from '@/features/decisions/components/canvas/DecisionCanvas';

export function Canvas() {
  return <DecisionCanvas />;
}
